import { ListByIdsResponseDto } from '@epicuro-next/data/engagement/engagement-models';

import { BestPerformingList } from '../../models';

export function mapBestPerformingLists(
  lists: ListByIdsResponseDto[],
  topListsWithOwners: BestPerformingList[],
) {
  const listsMapper = lists.map<[string, ListByIdsResponseDto]>((list) => [
    list?.id ?? '',
    list,
  ]);

  const listsMap = new Map(listsMapper);

  return topListsWithOwners.reduce((acc, list) => {
    const listInfo = listsMap.get(
      list.topListInfo.listId,
    ) as ListByIdsResponseDto;
    acc.push({ listInfo, ...list });

    return acc;
  }, [] as BestPerformingList[]);
}
